import React, { useCallback, useMemo } from 'react';

import './style.sass';

import { useModel } from 'app/hooks/useViewModel';
import { SideMenuViewModel } from 'app/viewModels/components/SideMenuModel';
import { observer } from 'mobx-react-lite';
import { useBreakpointType } from 'app/services/breakpoints';
import { DefaultMenu } from './DefaultMenu';
import { MobileMenu } from './MobileMenu';
import { Routes } from 'src/types/routes';

import noteIcon from 'assets/img/icons/note.svg';
import usersIcon from 'assets/img/icons/users.svg';
import logoutIcon from 'assets/img/icons/logout.svg';
import infoIcon from 'assets/img/icons/info-icon.svg';

export interface IMenuLink {
    title: string,
    link: string,
    icon: string
}

export interface IMenuItem extends Omit<IMenuLink, 'link'> {
    onClick: () => void,
}

const sideMenuIconsMap = {
    note: noteIcon,
    users: usersIcon,
    logout: logoutIcon,
    info: infoIcon,
};

export const SideMenu = observer(() => {
    const {
        sideMenuLinksByRole,
        sideMenuItems,
        isMenuOpened,
        handleCloseMenu,
    } = useModel(SideMenuViewModel);
    const { isMobile } = useBreakpointType();

    const menuLinksForRender = useMemo(
        () => sideMenuLinksByRole.map(item => {
            item.icon = sideMenuIconsMap[item.icon];
            return item;
        }),
        [sideMenuLinksByRole],
    );

    const menuItemsForRender = useMemo(
        () => sideMenuItems.map(item => {
            item.icon = sideMenuIconsMap[item.icon];
            return item;
        }),
        [sideMenuItems],
    );

    const onClickLogo = useCallback(() => {
        window.location.assign(Routes.Home);
    }, []);

    return (
        !isMobile
            ? <DefaultMenu
                menuLinks={menuLinksForRender}
                menuItems={menuItemsForRender}
                isActive={isMenuOpened}
                onClickLogo={onClickLogo}
            />
            : <MobileMenu
                menuLinks={menuLinksForRender}
                menuItems={menuItemsForRender}
                isActive={isMenuOpened}
                onClickNavLink={handleCloseMenu}
            />
    );
});

